const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: '34px',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
  },
})

export default styles
